import { put, call } from 'redux-saga/effects';
import { fetchLocalityService, fetchDistrictService } from '../services/localityService';

import * as types from '../actions'

export function* fetchLocalitySaga(payload) {
  try {
    const response = yield call(fetchLocalityService, payload);
    yield put({ type: types.LOCALITY_FETCH_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.LOCALITY_FETCH_ERROR, error })
  }
}

export function* fetchDistrictSaga(payload) {
  try {
    const response = yield call(fetchDistrictService, payload);
    yield put({ type: types.DISTRICT_FETCH_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.DISTRICT_FETCH_ERROR, error })
  }
}